/**
 * Active Indicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ControlDto } from './control';


export interface ActiveIndicatorResponseDto { 
    id: string;
    walletId: string;
    indicatorId: string;
    /**
     * Nível societário alvo para monitoramento do indicador.
     */
    relationshipLevel: ActiveIndicatorResponseDto.RelationshipLevelEnum;
    control?: ControlDto;
}
export namespace ActiveIndicatorResponseDto {
    export const RelationshipLevelEnum = {
        Root: 'ROOT',
        L1: 'L1',
        L2: 'L2'
    } as const;
    export type RelationshipLevelEnum = typeof RelationshipLevelEnum[keyof typeof RelationshipLevelEnum];
}


